{
  "version": 1,
  "asset_id": "eb50bb5f-8d96-41e6-bd3a-03ddb7f45684",
  "project_id": "c58f887f-f697-4bad-adae-7db8315d1231",
  "url": "/__l5e/assets-v1/eb50bb5f-8d96-41e6-bd3a-03ddb7f45684/mads-poulsen.jpg",
  "r2_key": "a/v1/c58f887f-f697-4bad-adae-7db8315d1231/eb50bb5f-8d96-41e6-bd3a-03ddb7f45684/mads-poulsen.jpg",
  "original_filename": "mads-poulsen.jpg",
  "size": 191550,
  "content_type": "image/jpeg",
  "created_at": "2026-07-09T20:09:11Z"
}
